module.exports = __webpack_public_path__ + "img/icon-wa-notactive.7e0a06e8.svg";